import React from 'react';
import OverviewView from '../views/OverviewView';

const Dashboard = () => {
  return <OverviewView />;
};

export default Dashboard;